import { render, staticRenderFns } from "./ParkingList.vue?vue&type=template&id=59021222&"
import script from "./ParkingList.vue?vue&type=script&lang=js&"
export * from "./ParkingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports